export default "__VITE_ASSET__BN9QuVIH__"